/*
 * Weekplan Messages
 *
 * This contains all the text for the Weekplan component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  importShifts: {
    id: 'app.containers.ImportShiftsMenuItem.importShifts',
    defaultMessage: 'Import Shifts',
  },
  importShiftsSuccess: {
    id: 'app.containers.ImportShiftsMenuItem.importShiftsSuccess',
    defaultMessage: 'Successfully imported shifts',
  },
  importShiftsFailure: {
    id: 'app.containers.ImportShiftsMenuItem.importShiftsFailure',
    defaultMessage: 'Error. Importing shifts failed.',
  },
});
